export default "/_next/static/images/6806f94c49b55530edcb009d5eeb0bbb.jpg";